import React, { createContext, useState } from "react";
import { v4 as uuid } from "uuid";

const NotificationsContext = createContext();

const NotificationsContextProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // notification is of type { show: boolean, type: "Success" | "Error", description: string | jsx component }
  const addNotification = (notification) => {
    setNotifications((prevNotifications) => [...prevNotifications, { ...notification, id: uuid() }]);
  };

  const removeNotification = (notificationId) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((notification) => notification.id !== notificationId)
    );
  };

  return (
    <NotificationsContext.Provider value={{ notifications, addNotification, removeNotification }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export { NotificationsContext, NotificationsContextProvider };
